// extracted by mini-css-extract-plugin
module.exports = {"container":"FullScreenSpinner_container__QEB4d","isSecondary":"FullScreenSpinner_isSecondary__PDCtm","billingSubmitting":"FullScreenSpinner_billingSubmitting__MoUFD"};